import type { ReactNode } from "react"
import React from "react"
import { Box, Text } from "@mallardbay/lib-react-components"

import type { OutfitterCancellationPolicyFieldsFragment } from "~graphql/generated/graphql"
import useModalState from "~utils/use-modal-state"
// TODO: Switch to use the shared component lib modal
import MbModal from "~components/shared/mb-modal"
import COPY from "~config/copy-constants"

interface Props {
    readonly cancellationPolicy: OutfitterCancellationPolicyFieldsFragment
    readonly renderTrigger: () => ReactNode
}

export default function CancellationPolicyModal({
    cancellationPolicy,
    renderTrigger,
}: Props) {
    const { isModalOpen, openModal, closeModal } = useModalState()

    return (
        <>
            <Box onClick={openModal}>{renderTrigger()}</Box>
            <MbModal
                isOpen={isModalOpen}
                onClose={closeModal}
                title={COPY.CANCELLATION_POLICY}
            >
                <Text>{cancellationPolicy.description}</Text>
            </MbModal>
        </>
    )
}
